import { render, staticRenderFns } from "./XtendTabs.vue?vue&type=template&id=67ce478a&"
import script from "./XtendTabs.vue?vue&type=script&lang=js&"
export * from "./XtendTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports